import axios from 'axios';
import { mockAuthHeaders } from '../utils/mockAuth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const headers = () => ({ ...mockAuthHeaders() });

export async function getPreferences() {
  const res = await axios.get(`${API_URL}/api/preferences`, { headers: headers() });
  return res.data;
}

export async function savePreferences(prefs) {
  const res = await axios.put(`${API_URL}/api/preferences`, prefs, { headers: headers() });
  return res.data;
}
